import { Badge, Tooltip } from "antd";

export const ChatStatus = ({ connectionStatus, isConnected, isMobile }: { connectionStatus: string, isConnected: boolean, isMobile: boolean }) => {
  return (
    <Tooltip title={connectionStatus}>
        <Badge
            dot
            color={isConnected ? 'green' : 'red'}
            style={{
                position: isMobile ? 'fixed' : 'absolute',
                bottom: isMobile ? 45 : 65,
                left: 10,
            }}
        />
    </Tooltip>
  )
} 
export default ChatStatus;